module.exports = __webpack_public_path__ + "static/banner-06da30ce74c16b25983c7006d2da62fb.jpg";